import React, { FC } from 'react';
import { configuration } from 'config/constants';
import { isFunction } from 'lodash-es';
import { useEffect, useState } from 'react';
import { Script } from 'services/loadScript';

interface IProps {
    script: string;
    children?: React.ReactNode | (() => React.ReactNode);
    onLoad?: () => void;
}
export const WidgetLazyLoader: FC<IProps> = ({ children, onLoad, script }) => {
    const [scriptLoaded, setScriptLoaded] = useState(false);

    useEffect(() => {
        (async () => {
            if (scriptLoaded) {
                return;
            }
            await Script.loadScript('widget-polyfill', `${configuration.widgetCdnBaseUrl}/widgets/sgwt-widget-polyfills/sgwt-widget-polyfill-webcomponent.js`, false);
            await Script.loadScript(script, script);
            setScriptLoaded(true);

            if (onLoad) {
                onLoad();
            }
        })();
    }, []);

    if (!scriptLoaded) {
        return null;
    }
    if (isFunction(children)) {
        return children();
    }
    return children;
};
